require("@fontsource/montserrat/latin-500.css")
require("@fontsource/montserrat/latin-300.css")
require("@fontsource/montserrat/latin-700.css")
require("@fontsource/montserrat/latin-400.css")
require("@fontsource/montserrat/latin-600.css")

const Sentry = require("@sentry/gatsby")

exports.onClientEntry = () => {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.NODE_ENV,
    release: process.env.SENTRY_RELEASE,
  })
}

exports.onServiceWorkerUpdateReady = () => {
  if (typeof window !== "undefined") {
    window.location.reload()
  }
}

exports.shouldUpdateScroll = ({
  prevRouterProps,
  routerProps: {
    location: { hash, key },
  },
}) => {
  if (typeof window !== "undefined") {
    const scrollContainer = document.querySelector("#gatsby-focus-wrapper")
    const previousKey = prevRouterProps?.location?.key
    const isInitialRender = !prevRouterProps
    const isSameHistoryEntry = previousKey && key && previousKey === key

    // Gatsby can update the router while hydrating the initial history entry.
    // Preserve any scrolling that happened while the JavaScript bundle loaded.
    if (!hash && (isInitialRender || isSameHistoryEntry)) return false

    if (hash && document.getElementById("beginning")) {
      const target = document.getElementById(hash.replace("#", ""))

      if (scrollContainer && target) {
        scrollContainer.style.scrollBehavior = "smooth"
        scrollContainer.scrollTop = target.offsetTop + 80
      }
    } else {
      if (!scrollContainer) return false

      scrollContainer.style.scrollBehavior = "unset"
      scrollContainer.scrollTop = 0

      if (document.getElementById("beginning")) {
        scrollContainer.style.scrollBehavior = "smooth"
      }
    }
  }
  return false
}
